import { Pagination } from "semantic-ui-react";
import { PageData as PageData } from "../../models/common_model";

export function Page<T>(props: {data?: PageData<T>, updatePage: React.Dispatch<any>}) {
    const {data, updatePage} = props;

    if (!data || data.pages === 1) {
        return <></>;
    }
    return <Pagination activePage={data.number} onPageChange={(e, d) => updatePage((p: any) => ({...p, page_number: d.activePage, page_size: data.size}))} totalPages={data.pages} />
}